// The one place the /voice voice list lives. Client-safe: no imports, no env.
//
// To swap a voice, edit one entry here, then run
//   ELEVENLABS_API_KEY=... pnpm exec tsx scripts/ops/generate-voice-samples.ts
// to render its sample into public/audio/voice-samples/. Every id must already
// be in the ElevenLabs account behind the site's key (GET /v2/voices), or the
// route returns a voice_not_found error. Library voices are added to the
// account in the ElevenLabs dashboard; the site's key cannot do that.
//
// ElevenLabs retires its Default voices on 2026-12-31
// (elevenlabs.io/docs/help-center/product/voices/my-voices/what-are-default-voices),
// so none of the retired ones (Sarah, Liam, Charlie, Lily, Bill) may come back.

/** The line every sample speaks. 21 characters, so a full re-render costs 126. */
export const VOICE_SAMPLE_LINE = 'Locked. See you soon.'

export const VOICE_SAMPLE_DIR = '/audio/voice-samples'

export interface CatalogVoice {
  /** ElevenLabs voice_id. */
  readonly id: string
  /** Name shown on the page. */
  readonly name: string
  /** Short descriptor shown beside the name. */
  readonly description: string
  /** File slug under public/audio/voice-samples/. */
  readonly slug: string
  /**
   * How much longer than the average voice this one takes to say a line, for
   * the length estimate. Measured on eleven_v4 on 2026-10-06: Arena took
   * 2.48 s for the 21-character sample and 5.12 s for a 66-character line,
   * 1.2 to 1.4 times the average fit in lib/voice-length.ts.
   */
  readonly pace: number
}

export const VOICE_CATALOG: readonly CatalogVoice[] = [
  { id: 'aMSt68OGf4xUZAnLpTU8', name: 'Juniper', slug: 'juniper', pace: 1, description: 'Relaxed, casual American woman' },
  { id: '56AoDkrOh6qfVPDXZ7Pt', name: 'Cassidy', slug: 'cassidy', pace: 1, description: 'Confident, clear American woman' },
  { id: 'XB0fDUnXU5powFXDhCwa', name: 'Helen', slug: 'helen', pace: 1, description: 'Warm, composed British woman' },
  { id: 'pNInz6obpgDQGcFmaJgB', name: 'Adam', slug: 'adam', pace: 1, description: 'Bright, brash American man' },
  { id: 'gU0LNdkMOQCOrPrwtbee', name: 'Match Day', slug: 'match-day', pace: 1, description: 'Fast, excited older British man' },
  { id: 'YOq2y2Up4RgXP2HyXjE5', name: 'Arena', slug: 'arena', pace: 1.3, description: 'Deep, metallic retro announcer' },
]

export function voiceSampleUrl(voice: Pick<CatalogVoice, 'slug'>): string {
  return `${VOICE_SAMPLE_DIR}/${voice.slug}.mp3`
}
